import axios from 'axios';
import { SERVER_URL } from "../const";
import Qs from 'qs';


export const getIGSTDataService = async (iec_no, filters) => {
  const token = localStorage.getItem('token');
  try {
    let params = {
      iec_no,
      ...filters,
      br_code: filters.br_code
    };
    // Make a GET request to fetch IGST data based on the IEC number
    const response = await axios.get(`${SERVER_URL}/get-igst-details`, {
      params,
      paramsSerializer: params => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data; // Return the data from the response
  } catch (error) {
    throw new Error('Error fetching IGST data:', error);
  }
};


